import React from 'react'

import SubscribeHeaderBanner from 'compositions/banners/SubscribeHeaderBanner/SubscribeHeaderBanner'

import useBanner from './util/useBanner'
import CardUpdateBanner from './components/CardUpdateBanner/CardUpdateBanner'
import UndeliverableBanner from './components/UndeliverableBanner/UndeliverableBanner'
import BannersCarousel from './components/BannersCarousel/BannersCarousel'
import TossInBanner from './components/TossInBanner/TossInBanner'
import PrivateSaleBanner from './components/PrivateSaleBanner/PrivateSaleBanner'
import UnskipBanner from './components/UnskipBanner/UnskipBanner'
import CandleSubscriptionBanner from './components/CandleSubscriptionBanner/CandleSubscriptionBanner'
import HolidaySeasonBanner
  from './components/HolidaySeasonBanner/HolidaySeasonBanner'


const Banner: React.FunctionComponent = () => {
  const {
    isFetching,
    isCardUpdateBannerVisible,
    isSubscribeBannerVisible,
    isUndeliverableBannerVisible,
    isTossInBannerVisible,
    isPrivateSaleBannerVisible,
    isUnskipBannerVisible,
    isCandleSubscriptionBannerVisible,
    isHolidayBannerVisible,
  } = useBanner()

  if (isFetching) {
    return null
  }

  if (isUnskipBannerVisible) {
    return (
      <UnskipBanner />
    )
  }

  if (isCardUpdateBannerVisible) {
    return (
      <CardUpdateBanner />
    )
  }

  if (isUndeliverableBannerVisible) {
    return (
      <UndeliverableBanner />
    )
  }

  if (isHolidayBannerVisible) {
    return (
      <HolidaySeasonBanner />
    )
  }

  if (isSubscribeBannerVisible) {
    return (
      <SubscribeHeaderBanner />
    )
  }

  const banners = []

  if (isCandleSubscriptionBannerVisible) {
    banners.push(<CandleSubscriptionBanner key="candleSubscription" position={banners.length + 1} />)
  }

  if (isTossInBannerVisible) {
    banners.push(<TossInBanner key="tossIn" position={banners.length + 1} />)
  }

  if (isPrivateSaleBannerVisible) {
    banners.push(<PrivateSaleBanner key="privateSale" position={banners.length + 1} />)
  }

  return (
    <BannersCarousel>
      {banners}
    </BannersCarousel>
  )
}


export default Banner
